import React from 'react'
import ContentHeader from '@Components/ContentHeader'
import MatchHistoryStatusSection from '@Components/MatchComponents/MatchHistory/MatchHistoryStatusSection'
import MatchHistorySearchHeader from '@Components/MatchComponents/MatchHistory/MatchHistorySearchHeader'
import BackButton from '@App/kit/components/Buttons/BackButton'
import './index.scss'
import { useOutletContext } from 'react-router'

const MatchHistorySearchContentHeader = () => {
    const { isSongwriterHub } = useOutletContext<{ isSongwriterHub: boolean }>()

    return (
        <div className="match-history-head">
            <ContentHeader
                title="Match History"
                descriptionElement={<MatchHistorySearchHeader />}
                navLeft={<BackButton />}
            >
                <MatchHistoryStatusSection isSongwriterHub={isSongwriterHub} />
            </ContentHeader>
        </div>
    )
}

export default MatchHistorySearchContentHeader
